module.exports = __webpack_public_path__ + "static/media/4-d_old.fea3c890.png";